module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9.51\" height=\"15.29\" viewBox=\"0 0 9.51 15.29\"><g id=\"b43ee465-c72e-4b68-b0a9-70c671c34b3d\" data-name=\"Calque 2\"><g id=\"f077ad3a-fac3-43e8-a6fc-d77ec4d7b7b8\" data-name=\"Calque 1\"><path d=\"M1.22,15.29A1.22,1.22,0,0,1,.4,13.16L6.47,7.64.4,2.13A1.22,1.22,0,0,1,2.05.32L9.11,6.74a1.22,1.22,0,0,1,0,1.81L2.05,15A1.25,1.25,0,0,1,1.22,15.29Z\" fill=\"#231f20\"/></g></g></svg>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/assets/icons/icon-right.svg
// module id = gICq
// module chunks = 1